<template>
  <v-expansion-panel class="onboarding-group">
    <v-expansion-panel-header class="py-3">
      <div class="d-flex align-center">
        <v-icon :color="isComplete ? 'success' : 'grey'" class="mr-3" size="22">
          {{ isComplete ? 'mdi-check-circle' : categoryIcon }}
        </v-icon>
        <div class="flex-grow-1">
          <span class="font-weight-medium group-title">{{ title }}</span>
        </div>
        <v-chip x-small :color="isComplete ? 'success' : 'grey lighten-2'" :text-color="isComplete ? 'white' : 'grey darken-1'" class="mr-2">
          {{ completedCount }}/{{ steps.length }}
        </v-chip>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="px-0">
      <div class="steps-container">
        <onboarding-step v-for="step in steps"
                         :key="step.key"
                         :step="step"
                         :completed="isStepComplete(step.key)"/>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'
import OnboardingStep from './OnboardingStep.vue'
import { OnboardingStep as OnboardingStepType } from '@/hooks/useOnboarding'

// Mapeamento de categoria para icone
const categoryIcons: Record<string, string> = {
  setup: 'mdi-cog-outline',
  integrations: 'mdi-puzzle-outline',
  finance: 'mdi-currency-usd',
  first_project: 'mdi-folder-plus-outline',
  first_contract: 'mdi-file-document-edit-outline'
}

export default defineComponent({
  name: 'OnboardingGroup',
  components: {
    OnboardingStep
  },
  props: {
    category: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    steps: {
      type: Array as PropType<OnboardingStepType[]>,
      required: true
    }
  },
  setup(props) {
    // Os steps ja vem com isCompleted do progressByCategory no widget pai
    const isStepComplete = (stepKey: string): boolean => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const step = props.steps.find((s: any) => s.key === stepKey)
      return step?.isCompleted ?? false
    }

    const completedCount = computed(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return props.steps.filter((step: any) => step.isCompleted).length
    })

    const isComplete = computed(() => {
      return completedCount.value === props.steps.length && props.steps.length > 0
    })

    const categoryIcon = computed(() => {
      return categoryIcons[props.category] || 'mdi-checkbox-blank-circle-outline'
    })

    return {
      isStepComplete,
      completedCount,
      isComplete,
      categoryIcon
    }
  }
})
</script>

<style lang="scss" scoped>
.onboarding-group {
  &::before {
    box-shadow: none !important;
  }

  .group-title {
    font-size: 15px;
  }

  .steps-container {
    padding: 0 16px 8px 16px;
  }
}

// Remover borda inferior do expansion panel
::v-deep .v-expansion-panel-content__wrap {
  padding-left: 0;
  padding-right: 0;
}
</style>
